require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-planning-competitor-marketing-analysis.json") })
        }
      }, "path---services-planning-competitor-marketing-analysis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-planning-competitor-marketing-analysis!./.cache/json/services-planning-competitor-marketing-analysis.json
// module id = 766
// module chunks = 231608221292675